import { ContratoModel } from "model/api/gestao/contrato/contrato-model";
import { CardNaoEncontrado } from "views/components/cards";
import { CardContratos } from "views/components/cards/card-contratos";
import { InformacaoIcon } from "views/components/icons";

export interface ClienteContratosGridProps {
  list: Array<ContratoModel>;
  carregando: boolean;
  selectedList: Array<string>;
  onCardSelected: (id: string) => any;
  onCardChecked: (id: string) => any;
  isTipoRevenda: boolean;
  pessoaId: string;
}

export const AccordionClienteContratosListData = (props: ClienteContratosGridProps) => {

  const onCardSelected = (id: string) => {
    props.onCardSelected(id);
  };

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {props.list.length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem="Nenhum Contrato Encontrado."
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}
      {props?.list.length > 0 &&
        props.list.map((items, index) => {
          return (
            <CardContratos
              selected={
                props.selectedList.filter((item) => item === items.id).length >
                  0
                  ? true
                  : false
              }
              onCheck={onCardChecked}
              onClick={onCardSelected}
              model={items}
              key={index}
              isTipoRevenda={props.isTipoRevenda}
              pessoaId={props.pessoaId}
            />
          );
        })}
    </>
  );
};
